import { render, staticRenderFns } from "./new-pricing.vue?vue&type=template&id=51bedbde"
import script from "./new-pricing.vue?vue&type=script&lang=js"
export * from "./new-pricing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports